import { createReducer } from '@reduxjs/toolkit';

import { setTheme, setCompleteTheme, setHighContrast, toggleTheme } from '../actions/themeActions';
import { initialThemeState } from '../initialState';

/**
 * Theme reducer for the core domain
 */
const themeReducer = createReducer(initialThemeState, builder => {
  builder
    .addCase(setTheme, (state, action) => {
      state.theme = action.payload;
    })
    .addCase(setCompleteTheme, (state, action) => {
      state.completeTheme = action.payload;

      // Update isHighContrast based on the completeTheme
      const themeString = action.payload.toString();

      state.isHighContrast = themeString.includes('hc-');
    })
    .addCase(setHighContrast, (state, action) => {
      state.isHighContrast = action.payload;
    })
    .addCase(toggleTheme, state => {
      // Toggle between light and dark, preserving system if that's the current value
      if (state.theme === 'light') {
        state.theme = 'dark';
      } else if (state.theme === 'dark') {
        state.theme = 'light';
      }
      // If theme is 'system', leave it as is
    });
});

export default themeReducer;
